import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const SourceEmptyState = {
  sources: [],
  selectedSource: null,
};

export const SourceKey = 'sources';

export const sourcesSlice = createSlice({
  name: 'sources',
  initialState: getLocalStorage(LocalStorageTypes.SOURCES)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.SOURCES))
    : SourceEmptyState,
  reducers: {
    setSources: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.SOURCES, result);
      return { ...state, ...action.payload };
    },
    updateSelectedSource: (state, action) => {
      const result = { ...state, ...action.payload };
      persistLocalStorage(SourceKey, result);
      return { ...state, ...action.payload };
    },
    resetSources: () => {
      clearLocalStorage('sources');
      return SourceEmptyState;
    },
  },
});

export const { setSources, updateSelectedSource, resetSources } =
  sourcesSlice.actions;
